<!-- 发起人名称 -->
<template>
  <div>
    <k-form-build :value="jsonData" ref="KFB" />
  </div>
</template>
<script>
export default {
  name: 'PromoterName',
  data() {
    return {
      jsonData: {
        list: [
          {
            type: 'input',
            icon: 'icon-edit',
            options: {
              width: '100%',
              minRows: 4,
              maxRows: 6,
              maxLength: null,
              defaultValue: '',
              clearable: false,
              hidden: false,
              placeholder: '发起人名称',
            },
            model: 'a1b2c3d4-e5f6-4g7h-8i9j-k0l1m2n3o4p5',
            key: 'a1b2c3d4-e5f6-4g7h-8i9j-k0l1m2n3o4p5',
            rules: [
              {
                required: false,
                message: '必填项',
              },
            ],
          },
        ],
        config: {
          layout: 'vertical',
          labelCol: {
            span: 4,
          },
          wrapperCol: {
            span: 18,
          },
          hideRequiredMark: false,
          customStyle: '',
        },
      },
    };
  },
  methods: {},
  mounted() {},
};
</script>
